// SKU-aware search results enhancement
// Calls the predictive search API (which does proper SKU prefix matching)
// and injects any additional SKU matches into the full-page search results grid.

(function () {
  'use strict';

  if (window.location.pathname !== '/search') return;

  var q = new URLSearchParams(window.location.search).get('q');
  if (!q || q.length < 2) return;

  var suggestUrl =
    '/search/suggest?q=' + encodeURIComponent(q) +
    '&resources%5Btype%5D=product' +
    '&resources%5Blimit%5D=10' +
    '&resources%5Boptions%5D%5Bfields%5D=title%2Cproduct_type%2Cvariants.title%2Cvariants.sku%2Cvendor%2Ctag' +
    '&section_id=predictive-search';

  fetch(suggestUrl)
    .then(function (r) { return r.text(); })
    .then(function (html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');

      // Extract product entries from predictive section
      var anchors = Array.from(doc.querySelectorAll('a[href*="/products/"]'));
      if (!anchors.length) return;

      var seen = new Set();
      var products = [];

      anchors.forEach(function (a) {
        var raw = a.getAttribute('href') || '';
        var path = raw.split('?')[0];
        if (!path || seen.has(path)) return;
        seen.add(path);

        var titleEl =
          a.querySelector('.predictive-search__item-heading') ||
          a.querySelector('.predictive-search__item-title') ||
          a.querySelector('h3, strong');
        var title = (titleEl ? titleEl.textContent : a.textContent).trim();
        if (!title) return;

        var imgEl = a.querySelector('img');
        var imgSrc = imgEl
          ? (imgEl.getAttribute('src') || (imgEl.getAttribute('srcset') || '').split(',')[0].trim().split(' ')[0])
          : null;

        var priceEl =
          a.querySelector('.price-item--sale') ||
          a.querySelector('.price-item--regular') ||
          a.querySelector('[class*="price-item"]');
        var price = priceEl ? priceEl.textContent.trim() : null;

        products.push({ path: path, title: title, imgSrc: imgSrc, price: price });
      });

      if (!products.length) return;

      // Find the native search grid
      var grid = document.getElementById('product-grid');
      if (!grid) return;

      // Collect paths already shown by native search
      var existingPaths = new Set(
        Array.from(grid.querySelectorAll('a[href*="/products/"]')).map(function (a) {
          try { return new URL(a.href).pathname; } catch (e) { return a.getAttribute('href').split('?')[0]; }
        })
      );

      // Keep only products NOT already in native results
      var fresh = products.filter(function (p) { return !existingPaths.has(p.path); });
      if (!fresh.length) return;

      // Find the <ul> inside the grid
      var ul = grid.querySelector('ul.product-grid') || grid.querySelector('ul');

      fresh.forEach(function (p) {
        var li = document.createElement('li');
        li.className = 'grid__item';

        var imgHtml = p.imgSrc
          ? '<div class="media media--transparent media--hover-effect" style="position:relative;overflow:hidden;">' +
            '<img src="' + p.imgSrc.replace(/"/g, '&quot;') + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy" width="533" height="533" style="display:block;width:100%;height:100%;object-fit:cover;"></div>'
          : '<div style="padding-top:100%;background:#f6f6f6;"></div>';

        var priceHtml = p.price
          ? '<div class="price"><span class="price-item price-item--regular">' + p.price + '</span></div>'
          : '';

        li.innerHTML =
          '<div class="card-wrapper product-card-wrapper underline-links-hover">' +
            '<div class="card card--standard card--media" tabindex="-1">' +
              '<div class="card__inner ratio" style="--ratio-percent:100%">' +
                '<div class="card__media">' + imgHtml + '</div>' +
              '</div>' +
              '<div class="card__content">' +
                '<div class="card__information">' +
                  '<h3 class="card__heading h5"><a href="' + p.path + '" class="full-unstyled-link">' +
                    p.title.replace(/</g, '&lt;').replace(/>/g, '&gt;') +
                  '</a></h3>' +
                '</div>' +
                priceHtml +
              '</div>' +
            '</div>' +
          '</div>';

        if (ul) {
          ul.appendChild(li);
        } else {
          grid.appendChild(li);
        }
      });

      // Update result count text if present
      var statusEl = document.querySelector('[role="status"]');
      if (statusEl) {
        statusEl.textContent = statusEl.textContent.replace(/\d+/, function (n) {
          return parseInt(n, 10) + fresh.length;
        });
      }

    })
    .catch(function () {});
})();
